import {
  SettingName,
  SettingValue,
  TeamSettingName,
  WorkspaceSettingName
} from 'v5/api/system-settings/settingCatalog';
import { ResolvedSetting } from 'v5/api/system-settings/system-settings.api';
import { WriteScopeFor } from './resolveSystemSettings';

/**
 * A patch value that drops the scope's own row, so the setting reads its parent's again. The
 * organisation's value has no parent and is only ever changed.
 */
export const inheritFromParent = Symbol('inheritFromParent');

export type SettingsPatch<K extends SettingName> = {
  [P in K]?: SettingValue<P> | typeof inheritFromParent;
};

export interface SystemSettingsMutationService {
  updateSetting: {
    <K extends WorkspaceSettingName>(
      scope: WriteScopeFor<K>,
      name: K,
      value: SettingValue<K>
    ): Promise<ResolvedSetting<SettingValue<K>>>;
    <K extends TeamSettingName>(
      scope: WriteScopeFor<K>,
      name: K,
      value: SettingValue<K>
    ): Promise<ResolvedSetting<SettingValue<K>>>;
  };
  /** Several settings at the scope's own row: stored in one request, or dropped to inherit. */
  updateSettings: <K extends SettingName>(
    scope: WriteScopeFor<K>,
    patch: SettingsPatch<K>
  ) => Promise<void>;
}

export interface WithSystemSettingsMutationService {
  systemSettingsMutationService: SystemSettingsMutationService;
}

export type { SettingName };
